<div class="dialog-perfil">
  <div class="dialog-perfil__cabecalho">
    <h2>Atualizar dados</h2>
  </div>

  <form [formGroup]="perfilForm" (ngSubmit)="salvar()" autocomplete="off">
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Nome</mat-label>
      <input matInput type="text" formControlName="noNomeCompleto" maxlength="100" autocomplete="name" [errorStateMatcher]="semEstadoVisualDeErro">
    </mat-form-field>

    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>E-mail</mat-label>
      <input matInput type="email" formControlName="noEmail" maxlength="80" autocomplete="email" [errorStateMatcher]="semEstadoVisualDeErro">
    </mat-form-field>

    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Celular</mat-label>
      <input matInput type="text" formControlName="nrCelular" mask="+00 (00) 00000-0000" autocomplete="tel" [errorStateMatcher]="semEstadoVisualDeErro">
    </mat-form-field>

    <div class="dialog-perfil__acoes">
      <button mat-button type="button" (click)="cancelar()" [disabled]="salvando">Cancelar</button>
      <button
        mat-raised-button
        color="primary"
        type="submit"
        [disabled]="perfilForm.invalid || perfilForm.pristine || carregando || salvando">
        Salvar
      </button>
    </div>
  </form>

  <div class="dialog-perfil__carregando" *ngIf="carregando">
    <mat-spinner diameter="36"></mat-spinner>
  </div>
</div>
